const CrossOriginLocalStorage = function (currentWindow, iframe) {
  let childWindow;

  try {
    childWindow = iframe.contentWindow;
  } catch (e) {
    childWindow = iframe.contentWindow;
  }

  this.getData = (key) => {
    const messageData = {
      key: key,
      method: 'get',
    }

    this.postMessage(messageData);
  }

  this.setData = (key, data) => {
    const messageData = {
      key: key,
      method: 'set',
      data: data
    }

    this.postMessage(messageData);
  }

  this.postMessage = (messageData) => {
    childWindow.postMessage(JSON.stringify(messageData), '*');
  }
};

const pushOrigins = [
  'https://www.eposnow.com/cloudamp/',
  'https://archive.eposnow.com/cloudamp/',
  'https://store.eposnow.com/cloudamp/',
];

const allowedOrigins = [
  'https://www.eposnow.com',
  'https://archive.eposnow.com',
  'https://store.eposnow.com',
  'https://ss.eposnow.com'
];

const sendReceive = (typeof _cloudampReceiver === 'undefined');

sendReceive && window.addEventListener('load', () => {
  pushOrigins.forEach((url, i) => {
    let frame = document.createElement('iframe');
    frame.src = url;
    frame.id = '_cloudamp-' + i;
    frame.style.position = 'absolute';
    frame.width = 0;
    frame.height = 0;
    frame.title = 'CloudAmp ' + i;

    frame.onload = () => {
      let cross = new CrossOriginLocalStorage(window, frame);
      let data = localStorage.getItem('_ca_data') || false,
        history = localStorage.getItem('_ca_history') || false;

      data && cross.setData('_ca_data', data);
      history && cross.setData('_ca_history', history);
    }

    document.documentElement.appendChild(frame);
  });
})

!sendReceive && (window.onmessage = (e) => {
  if (!allowedOrigins.includes(e.origin) || !e.data) return;

  const payload = JSON.parse(e.data);

  switch (payload.method) {
    case 'set':
      localStorage.setItem(payload.key, payload.data);
      break;
  }
})
